import { c as _c } from "react/compiler-runtime";
import { Section } from '~/components/marketing/Section';
import type { BlueprintSearchRecord } from '~/libs/dato/fragments/components/blueprintSearchFragment';
import { isNotEmptyString } from '~/utils/datoHelpers';
import { BpiLinkBanner } from './BpiLinkBanner';
type BpiLinkBannerSectionProps = {
  data: BlueprintSearchRecord;
};
const BpiLinkBannerSection = t0 => {
  const $ = _c(8);
  const {
    data
  } = t0;
  const {
    bannerHeading,
    ctaLabel,
    ctaLink,
    durationFilter,
    featureFilter,
    searchFilter
  } = data;
  const t1 = isNotEmptyString(bannerHeading) ? bannerHeading : undefined;
  const t2 = isNotEmptyString(ctaLabel) ? ctaLabel : undefined;
  const t3 = isNotEmptyString(ctaLink) ? ctaLink : undefined;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      name: "landing_page_see_all_trips",
      label: "See all trips: landing page BPI banner"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== durationFilter || $[2] !== featureFilter || $[3] !== searchFilter || $[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t5 = <Section><BpiLinkBanner label={t1} ctaLabel={t2} href={t3} searchFilter={searchFilter} featureFilter={featureFilter} durationFilter={durationFilter} tracking={t4} /></Section>;
    $[1] = durationFilter;
    $[2] = featureFilter;
    $[3] = searchFilter;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { BpiLinkBannerSection };